import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './auth/useAuth';
import { AppRouter } from './app/AppRouter';
import { SignedOutApp } from './features/public/PublicRoutes';
import { PublicAccessContext } from './features/public/publicAccess';
import { ActiveTenantProvider } from './tenancy/ActiveTenantProvider';

export default function App() {
  const { t } = useTranslation();
  const auth = useAuth();
  if (auth.isLoading)
    return (
      <main className="auth-callback">
        <p>{t('common.loading')}</p>
      </main>
    );
  // #885: signed out, the public catalog is open; everything else asks to sign in.
  if (!auth.user)
    return (
      <BrowserRouter>
        <SignedOutApp signIn={auth.signIn} signUp={auth.signUp} signInError={auth.signInError} />
      </BrowserRouter>
    );
  return (
    <>
      {auth.signInError ? (
        <p role="alert" className="import-error">
          {auth.signInError}
        </p>
      ) : null}
      <BrowserRouter>
        <PublicAccessContext.Provider value={{ signedIn: true, signIn: auth.signIn, signUp: auth.signUp }}>
          {/* #1051: keyed by user, so signing in as someone else starts from their own tenant. */}
          <ActiveTenantProvider key={auth.user.profile.sub} userId={auth.user.profile.sub}>
            <AppRouter />
          </ActiveTenantProvider>
        </PublicAccessContext.Provider>
      </BrowserRouter>
    </>
  );
}
